<fieldset>
  <legend>
    <i class="pi" *ngIf="doc.valid !== undefined"
      [ngClass]="{ 'pi-check': doc.valid, 'pi-times': doc.valid === false }"></i>
    {{ doc.name[appSettings.selectedLang] }}
  </legend>
  <li *ngIf="doc.reason && blockEdit">({{ doc.checkTime | date : 'dd.MM.yyyy HH:mm' }}) {{ doc.reason }}</li>

  <p-table [value]="doc.files">
    <ng-template pTemplate="body" let-file>
      <tr>
        <td *ngIf="file.filetype === 'Images'" class="prev_file">
          <app-full-image imageUrl="{{ appSettings.settings.urlFileDownload }}/competitor/uid/{{ file.uid }}"
            [width]="50" [alt]="file.description"></app-full-image>
        </td>
        <td *ngIf="file.filetype !== 'Images' && file.description.toLowerCase().endsWith('.pdf')" class="prev_file">
          <race-pdf-preview pdfSrc="{{ appSettings.settings.urlFileDownload }}/competitor/uid/{{ file.uid }}"
            [width]="100" [fullscreenEmit]="true"> </race-pdf-preview>
        </td>
        <td *ngIf="file.filetype !== 'Images' && !file.description.toLowerCase().endsWith('.pdf')" class="prev_file">
          <a href="{{ appSettings.settings.urlFileDownload }}/competitor/uid/{{ file.uid }}">
            <i class="pi pi-file"></i>
          </a>
        </td>
        <td>
          <a href="{{ appSettings.settings.urlFileDownload }}/competitor/uid/{{ file.uid }}">{{ file.description ?
            file.description : file.uid }}</a>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="2">{{ appSettings.translate[appSettings.selectedLang]['no_document'] }}</td>
      </tr>
    </ng-template>
  </p-table>

  <div *ngIf="!blockEdit">
    <div class="p-inputgroup document-buttons" *ngIf="doc.files.length">
      <p-button icon="pi pi-check" styleClass="button-success" (click)="setValid(doc, true)"></p-button>
      <p-button icon="pi pi-times" styleClass="button-danger" (click)="setValid(doc, false)"></p-button>
    </div>
    <div class="document-reason" *ngIf="doc.valid === false">
      <div>
        <span class="p-inputgroup-addon">{{ appSettings.translate[appSettings.selectedLang]['reason'] }}:</span>
      </div>
      <textarea rows="1" pInputTextarea maxlength="300" [(ngModel)]="doc.reason" [autoResize]="true"></textarea>
    </div>
  </div>
</fieldset>